import { render } from "./EditSubCommunityView.vue?vue&type=template&id=4fee15b2"
import script from "./EditSubCommunityView.vue?vue&type=script&lang=js"
export * from "./EditSubCommunityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__